<template>
    <div class="wlx-certcate-manager">

        <div class="add-partner-enterprise-head clearfix">
            <div class="top-page-top fl">
                <span class="sp-top-text">
                    <span>证书管理</span>
                </span>
            </div>
            <div class="fr btn-right">
                <el-form :inline="true" size="small">
                     <el-form-item>
                        <el-input v-model="stuName" placeholder="请输入学生名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="schoolName" placeholder="请输入单位名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="idCard" placeholder="请输入身份证号" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="examinationTypeId" clearable placeholder="请选择考核类型" @change="typeChnage">
                            <el-option v-for="item in searchCertTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="examinationGradeId" clearable placeholder="请选择考核等级">
                            <el-option v-for="item in searCertGradeList" :key="item.value" :label="item.lable" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" @click="getStudentResultInfo()">搜索</el-button>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addInfo">新增</el-button>
                        <el-button type="primary" icon="el-icon-search" @click="ImportDialogVisible = true">导入</el-button>
                        <el-button type="primary" icon="el-icon-delete" @click="DeleteAllDialogVisible = true">删除</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <el-table :data="list">
            <el-table-column label="序号" type="index"></el-table-column>
            <el-table-column prop="studentName" label="学生姓名"></el-table-column>
            <el-table-column prop="idCard" label="身份证号"></el-table-column>
            <!-- <el-table-column prop="examName" label="考核名称"></el-table-column> -->
            <el-table-column prop="examTime" label="考核时间"></el-table-column>
            <el-table-column prop="certificateType" label="证书类型"></el-table-column>
            <el-table-column prop="examinationGrade" label="证书等级"></el-table-column>
            <!-- <el-table-column prop="siteName" label="考核站点"></el-table-column> -->
            <el-table-column prop="dateofIssue" label="发证时间"></el-table-column>
            <el-table-column prop="certificateNum" label="证书编号"></el-table-column>
            <el-table-column prop="dateCreated" label="创建日期"></el-table-column>
            <el-table-column label="操作" width="200px">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="deleteInfo(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="u-page-con">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="onPageChangeHandler"
                :current-page="page"
                :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
                v-show="totalCount > 0"
                style="text-align: center;"
            ></el-pagination>
        </div>

        <el-dialog title="编辑" :modal="false" :visible.sync="dialogFormVisible" width="800px">
            <el-form :inline="true" :model="from" class="demo-form-inline" label-width="120px">
                <el-form-item label="学生姓名">
                    <el-input v-model="from.studentName"></el-input>
                </el-form-item>
                <el-form-item label="身份证号">
                    <el-input v-model="from.idCard"></el-input>
                </el-form-item>
                <el-form-item label="考核名称">
                    <el-input v-model="from.examName"></el-input>
                </el-form-item>
                <el-form-item label="考核时间">
                    <el-date-picker type="date" placeholder="选择日期" v-model="from.examTime" style="width: 100%;"></el-date-picker>
                </el-form-item>
                <el-form-item label="证书编号">
                    <el-input v-model="from.certificateNum"></el-input>
                </el-form-item>
                <el-form-item label="发证时间">
                    <el-date-picker type="date" placeholder="选择日期" v-model="from.dateofIssue" style="width: 100%;"></el-date-picker>
                </el-form-item>
                <el-form-item label="证书类型">
                    <el-select v-model="from.examinationTypeId" placeholder="请选择" @change="typeChnage">
                        <el-option v-for="item in certTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="证书等级">
                    <el-select v-model="from.examinationGradeId" placeholder="请选择">
                        <el-option v-for="item in certGradeList" :key="item.value" :label="item.lable" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="考核站点">
                    <el-input v-model="from.siteName"></el-input>
                </el-form-item>
                <el-form-item v-show="from.examYMEnglish != ''" label="考核年月英文">
                    <el-input disabled v-model="from.examYMEnglish"></el-input>
                </el-form-item>
                <el-form-item v-show="from.examinationGradeEnglish != ''" label="考核等级英文">
                    <el-input disabled v-model="from.examinationGradeEnglish"></el-input>
                </el-form-item>
                <el-form-item v-show="from.studentNamePinyin != ''" label="学生名称拼音">
                    <el-input disabled v-model="from.studentNamePinyin"></el-input>
                </el-form-item>
                <!-- <el-form-item label="是否合格">
          <el-radio-group v-model="from.qualifiedState">
            <el-radio label="合格">合格</el-radio>
            <el-radio label="不合格">不合格</el-radio>
            <el-radio label="缺考">缺考</el-radio>
          </el-radio-group>
        </el-form-item> -->
                <el-form-item label="学生头像">
                    <imageUpload class="img_upload" :url="urlAliyunOSS" :files.sync="from.studentUrl" v-if="dialogFormVisible" format="image"></imageUpload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelInfo">取 消</el-button>
                <el-button type="primary" @click="editInfo()">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :before-close="cancel" title="Excel导入" :visible.sync="ImportDialogVisible" width="50%" top="3%" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false">
            <el-form ref="form" label-width="80px" size="mini" @submit.prevent="importFile">
                <el-upload class="upload-demo" ref="upload" :action="uploadUrl" :file-list="fileList" :auto-upload="false" :on-success="onSuccess" accept="xls, xlsx" :limit="1" style="display: inline-block; text-align: center;margin-top:15px;">
                    <el-button slot="trigger" type="primary">选取文件</el-button>
                    <a style="color: #049cdb; text-decoration: underline;margin-left:15px;" href="/public/docs/证书信息导入模板.xlsx">下载模板</a>
                    <div slot="tip" class="el-upload__tip"></div>
                </el-upload>
                <p class="excelparaph" style="font-size:18px;margin:0px 0px 10px;">注意事项：</p>
                <ul class="attention_excel" style="font-size:16px;padding-left:40px;">
                    <li>1.请按照模板规范顺序导入数据,确认表格数据是否填写完整</li>
                </ul>
                <el-table :data="errorList" v-show="errorList.length > 0" style="width: 100%">
                    <el-table-column prop="stuName" label="行号" width="180"></el-table-column>
                    <el-table-column prop="errorMsg" label="错误" style="width:80%"></el-table-column>
                </el-table>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="importFile()">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 批量删除 -->
        <el-dialog :before-close="cancel" title="批量删除" :visible.sync="DeleteAllDialogVisible" width="30%" top="3%" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false">
            <el-form ref="form" label-width="120px" size="mini">
                <el-form-item label="开始时间">
                    <el-date-picker v-model="deleteStartTime" type="datetime" placeholder="选择开始时间"> </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间">
                    <el-date-picker v-model="deleteEndTime" type="datetime" placeholder="选择结束时间"> </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelDeleteAll">取 消</el-button>
                <el-button type="primary" @click="deleteAll()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
export default {
    data() {
        return {
            page: 1,
            pageSize: 10,
            totalCount: 0,
            stuName: "",
            schoolName: "",
            idCard: "",
            examinationTypeId: "",
            examinationGradeId: "",
            list: [],
            from: {
                id: "",
                studentName: "",
                examName: "",
                examTime: "",
                examinationTypeId: "",
                examinationType: "",
                examinationGradeId: "",
                examinationGrade: "",
                siteName: "",
                idCard: "",
                qualifiedState: "合格",
                certificateNum: "",
                dateofIssue: "",
                examYMEnglish: "",
                examinationGradeEnglish: "",
                studentNamePinyin: "",
                studentUrl: "",
            },
            files: [],
            urlAliyunOSS: "/api/design/osssign/getsign",
            //编辑信息
            dialogFormVisible: false,
            //导入
            ImportDialogVisible: false,
            // uploadUrl: "/api/XOrg/CertificateManager/uploadExcel",
            fileList: [], //导入文件
            errorList: [], //错误信息
            certTypeList: [],
            certGradeList: [],
            certTypeId: "",
            searchCertTypeList: [],
            searCertGradeList: [],
            // 批量删除
            DeleteAllDialogVisible: false,
            deleteStartTime: "",
            deleteEndTime: "",
        };
    },
    components: {
        imageUpload,
    },
    created() {
        this.getStudentResultInfo();
        this.getCertificateType();
        this.getSearchCertificateType();
    },
    computed: {
        uploadUrl(){
            return "/api/XOrg/CertificateManager/uploadExcel?certificateId="+this.certificateId;
        }
    },
    props:{
        certificateId:{
            default:"",
            type:String
        }
    },
    watch: {
        // eslint-disable-next-line no-unused-vars
        "from.examinationTypeId": function(val) {
            this.getCertificateGrade();
        },
        // eslint-disable-next-line no-unused-vars
        examinationTypeId: function(val) {
            this.getSearchCertificateGrade();
        },
    },
    methods: {
        deleteAll() {
            var that = this;
            this.$confirm("此操作将删除该时间段证书数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                that.$http
                    .post("/api/XOrg/CertificateManager/deleteCertificateAll", {
                        startTime: this.deleteStartTime,
                        endTime: this.deleteEndTime,
                    })
                    .then(function(rst) {
                        if (rst.code > 0) {
                            that.$message.success(rst.msg);
                            that.DeleteAllDialogVisible = false;
                            that.getStudentResultInfo();
                        } else {
                            that.$message.warning(rst.msg);
                        }
                    });
            });
        },
        cancelDeleteAll() {
            this.DeleteAllDialogVisible = false;
            this.deleteStartTime = "";
            this.deleteEndTime = "";
        },
        getSearchCertificateType() {
            var that = this;
            this.$http.post("/api/XOrg/CertificateTypeManager/getCertificateType",{
                certificateId:this.certificateId
            }).then(function(rst) {
                if (rst.code > 0) {
                    that.searchCertTypeList = rst.list;
                } else {
                    that.$message.warning(rst.msg);
                }
            });
        },
        getSearchCertificateGrade() {
            var that = this;
            this.$http
                .post("/api/XOrg/CertGradeMgr/getCertificateGrade", {
                    typeId: this.examinationTypeId,
                })
                .then(function(rst) {
                    if (rst.code > 0) {
                        that.searCertGradeList = rst.list;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        getCertificateType() {
            var that = this;
            this.$http.post("/api/XOrg/CertificateTypeManager/getCertificateType",{
                certificateId:this.certificateId
            }).then(function(rst) {
                if (rst.code > 0) {
                    that.certTypeList = rst.list;
                } else {
                    that.$message.warning(rst.msg);
                }
            });
        },
        typeChnage() {
            // this.getCertificateGrade();
            this.from.examinationGradeId = "";
        },
        getCertificateGrade() {
            var that = this;
            this.$http
                .post("/api/XOrg/CertGradeMgr/getCertificateGrade", {
                    typeId: this.from.examinationTypeId,
                })
                .then(function(rst) {
                    if (rst.code > 0) {
                        that.certGradeList = rst.list;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        cancelInfo() {
            this.from.id = "";
            this.from.studentName = "";
            this.from.examName = "";
            this.from.examTime = "";
            this.from.examinationTypeId = "";
            this.from.examinationType = "";
            this.from.examinationGradeId = "";
            this.from.examinationGrade = "";
            this.from.siteName = "";
            this.from.idCard = "";
            this.from.qualifiedState = "";
            this.from.certificateNum = "";
            this.from.dateofIssue = "";
            this.from.examYMEnglish = "";
            this.from.examinationGradeEnglish = "";
            this.from.studentNamePinyin = "";
            this.from.studentUrl = "";
            this.dialogFormVisible = false;
        },
        onSuccess(res) {
            if (res.code < 0) {
                if (res.code === -5) {
                    this.errorList = res.list;
                } else {
                    this.$message.warning(res.msg);
                }
            } else {
                this.ImportDialogVisible = false;
                this.$message.success("导入成功");
                this.fileList = [];
                this.getStudentResultInfo();
            }
        },
        //导入题库
        importFile() {
            this.$refs.upload.submit();
        },
        //清除数据
        cancel() {
            this.ImportDialogVisible = false;
            this.fileList = [];
        },
        addInfo() {
            this.dialogFormVisible = true;
        },
        //编辑
        editInfo() {
            var that = this;
            this.$http
                .post("/api/XOrg/CertificateManager/addOrEditCertificate", {
                    id: this.from.id,
                    studentName: this.from.studentName,
                    examName: this.from.examName,
                    examTime: this.from.examTime,
                    examinationGradeId: this.from.examinationGradeId,
                    examinationTypeId: this.from.examinationTypeId,
                    siteName: this.from.siteName,
                    idCard: this.from.idCard,
                    qualifiedState: this.from.qualifiedState,
                    certificateNum: this.from.certificateNum,
                    dateofIssue: this.from.dateofIssue,
                    studentUrl: this.from.studentUrl,
                    certificateId:this.certificateId
                })
                .then(function(rst) {
                    if (rst.code > 0) {
                        that.$message.success(rst.msg);
                        that.cancelInfo();
                        that.getStudentResultInfo();
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        //弹出框赋值
        handleEdit(row) {
            this.from.id = row.id;
            this.from.studentName = row.studentName;
            this.from.examName = row.examName;
            this.from.examTime = row.examTime;
            this.from.examinationGradeId = row.examinationGradeId;
            this.from.examinationTypeId = row.certificateTypeId;
            this.from.siteName = row.siteName;
            this.from.idCard = row.idCard;
            this.from.qualifiedState = row.qualifiedState;
            this.from.certificateNum = row.certificateNum;
            this.from.dateofIssue = row.dateofIssue;
            this.from.examYMEnglish = row.examYMEnglish;
            this.from.examinationGradeEnglish = row.examinationGradeEnglish;
            this.from.studentNamePinyin = row.studentNamePinyin;
            this.from.studentUrl = row.studentUrl;
            this.dialogFormVisible = true;
        },
        //删除
        deleteInfo(id) {
            var that = this;
            this.$confirm("此操作将删除该证书数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                that.$http
                    .post("/api/XOrg/CertificateManager/deleteCertificateInfo", {
                        ids: id,
                    })
                    .then(function(rst) {
                        if (rst.code > 0) {
                            that.$message.success(rst.msg);
                            that.getStudentResultInfo();
                        } else {
                            that.$message.warning(rst.msg);
                        }
                    });
            });
        },
        //查询
        getStudentResultInfo() {
            var that = this;
            this.$http
                .post("/api/XOrg/CertificateManager/getCertificateList", {
                    studentName: this.stuName,
                    schoolName: this.schoolName,
                    idCard: this.idCard,
                    ExaminationGradeId: this.examinationGradeId,
                    CertificateTypeId: this.examinationTypeId,
                    certificateId:this.certificateId,
                    type: 0,
                    PageSize: that.pageSize,
                    page: that.page,
                })
                .then(function(rst) {
                    if (rst.code > 0) {
                        that.list = rst.list;
                        that.page = rst.pagination.pageIndex;
                        that.pageSize = rst.pagination.pageSize;
                        that.totalCount = rst.pagination.totalCount;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getStudentResultInfo();
        },
        onPageChangeHandler(val) {
            this.page = val;
            this.getStudentResultInfo();
        },
    },
};
</script>

<style lang="scss">
.wlx-certcate-manager {
    background: #fff;
    padding-bottom: 20px;
    .add-partner-enterprise-head {
        border-bottom: 1px solid #F0F0F0;
        height: 60px;
        .add-banner-btn,
        .delete-banner-btn {
            margin-top: 13px;
        }
        .delete-banner-btn {
            margin-right: 62px;
        }
        .top-page-top{
            border: none;
        }
    }
    .banner-page-con {
        padding: 20px 0;
        text-align: center;
    }
    .el-table thead{
        color: #05243D;
    }
    .btn-right{
        margin-top: 14px;
    }
    .export-button-a {
        color: #fff;
        background: #409eff;
        padding: 8px 15px;
        border-radius: 4px;
        margin: 0 10px;
    }
}
</style>
